// Placeholder audio system. Silent by design in this phase, but wired to settings
// so that future sound files can be plugged in without changes to the scenes.
import { getSettings } from './settings';

export const AudioSystem = {
  playEffect(_name) {
    const s = getSettings();
    if (s.effectsVolume <= 0) return;
    // TODO: play sound with s.effectsVolume when audio assets are added
  },
  playMusic(_name) {
    const s = getSettings();
    if (s.musicVolume <= 0) return;
    // TODO: play music with s.musicVolume when audio assets are added
  },
  vibrate(pattern = 30) {
    const s = getSettings();
    if (!s.vibration) return;
    if (typeof navigator !== 'undefined' && navigator.vibrate) {
      try { navigator.vibrate(pattern); } catch { /* ignore */ }
    }
  },
};
